module.exports = __webpack_public_path__ + "static/img/10006 (1).29bc853.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/10000/10006 (1).webp
// module id = rN1L
// module chunks = 14